import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
import SpecialDialog from "@/components/management/special/SpecialDialog";
import { getTopicList, getTopicInfo, handleTopicDelete } from "@/api/managementCenter/specialManage";
export default {
  name: "Special",
  components: {
    Sift: Sift,
    SpecialDialog: SpecialDialog
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      siftData: [{
        type: "text",
        key: "name",
        label: "专题名称",
        placeholder: "请输入专题名称",
        default: ""
      }],
      list: [],
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10,
        name: ""
      },
      total: 0
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.getListFn();
  },
  methods: {
    // 获取查询列表
    getListFn: function getListFn() {
      var _this = this;

      this.loading = true;
      getTopicList(this.paramSearch).then(function (_ref) {
        var data = _ref.data;
        _this.loading = false;

        if (data.code == 0) {
          _this.list = data.data.records || [];
          _this.total = data.data.total;
        }
      }).catch(function () {
        _this.loading = false;
      });
    },
    // 添加
    addFn: function addFn() {
      this.$refs.SpecialDialog.dialogShow("add");
    },
    // 删除
    deleteFn: function deleteFn(id, name) {
      var _this2 = this;

      this.$confirm("是否确定删除" + name + " ?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this2.deleteHttp(id, name);
      }).catch(function () {
        _this2.$message.info("已取消删除");
      });
    },
    deleteHttp: function deleteHttp(id, name) {
      var _this3 = this;

      this.loading = true; // 删除接口

      handleTopicDelete(id).then(function (_ref2) {
        var data = _ref2.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.$message.success(name + "删除成功!");

          _this3.getListFn();
        } else {
          _this3.$message.warning(data.msg || "删除失败！");
        }
      }).catch(function () {
        _this3.loading = false;

        _this3.$message.error("删除异常!");
      });
    },
    // 详情
    editFn: function editFn(id, name) {
      var _this4 = this;

      this.loading = true;
      getTopicInfo(id).then(function (_ref3) {
        var data = _ref3.data;
        _this4.loading = false;

        if (data.code == 0) {
          _this4.$refs.SpecialDialog.dialogShow("edit", data.data);
        } else {
          _this4.$message.warning(data.msg || "获取专题信息失败！");
        }
      }).catch(function (err) {
        _this4.loading = false;
      });
    },
    // 默认页面数据
    initPage: function initPage() {
      this.paramSearch = _objectSpread(_objectSpread(_objectSpread({}, this.paramSearch), this.$refs.needSift.getValue()), {}, {
        current: 1
      });
      this.getListFn();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getListFn();
    },
    saveSuccess: function saveSuccess() {
      this.getListFn();
    }
  },
  watch: {},
  filters: {}
};